module.exports = __webpack_public_path__ + "img/22.dff48947.png";